import React from "react";
import {connect } from "react-redux";
import { useStyles } from "./style";
import { useHistory } from "react-router-dom";
import mapStateToProps from './mapStateToProps';
import {ListItem, ListItemIcon} from "@mui/material";
import './style.css'

const Menu = (props) => {
    const classes = useStyles(props);
    let history = useHistory();

    return (
        <div className="cardContainerMenu">
            {(props.menu!==null) ? props.menu.map((item,index)=>{
                return (
                    <div className="card" key={index}>
                        <div className="card-inner" key={index}>
                            <div>
                                <div className={classes.contenedorImagen}>
                                    <img src={"/menu/"+item.icon} alt={item.name} className={classes.registerImage} />
                                </div>
                                <h2 className={classes.cardTitle}>{item.name}</h2>
                                <div className={classes.lineaDegradadaDivider}></div>
                                    {(item.form!==null) ? item.form.map((form,formIndex)=>{
                                        return (
                                            <ListItem
                                            className={classes.listItem}
                                            key={formIndex}
                                            button onClick={()=>{
                                                history.push(form.path,{});
                                            }}
                                        >
                                            <ListItemIcon className={classes.listItemIcon}>
                                                <img className={classes.icon} src={"/menu/"+form.icon} alt="Italian Trulli"/>
                                            </ListItemIcon>
                                            <p className={classes.listButton}> {form.name} </p>
                                        </ListItem>
                                        )
                                    }) :""}
                            </div>
                        </div>
                    </div>
                )
            })
            :""
            }
        </div>
    )
};

export default connect(mapStateToProps)(Menu);
